<template>
    <div>
        <slot :entered="entered" />
    </div>
</template>

<script>
    export default {
        props: {
            enabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                entered: false,
            };
        },
        mounted() {
            if (! this.enabled) {
                this.entered = true;
                return;
            }

            const observer = new IntersectionObserver(([entry], observer) => {
                if (entry.intersectionRatio > 0) {
                    this.entered = true;
                    observer.disconnect();
                }
            });

            observer.observe(this.$el);
        },
    };
</script>
